import { render, h } from "preact";
import { toast, Toaster, ToasterProps } from "react-hot-toast";

type ExtendedToast = typeof toast & {
  setConfig: (config: Partial<ToasterProps>) => void;
};

declare global {
  interface Window {
    toast: ExtendedToast;
  }
}

let root: HTMLElement | null = null;

const startToaster = (config?: ToasterProps) => {
  if (!root) {
    root = document.createElement("div");
    root.id = "hot-toast";
    document.body.appendChild(root);
  }

  window.toast = toast as ExtendedToast;
  window.toast.setConfig = (config: Partial<ToasterProps>) => {
    startToaster(config);
  };

  window.toast.setConfig({
    toastOptions: {
      duration: 10000,
    },
  });

  render(<Toaster {...config} />, root);
};

startToaster();

export { toast, startToaster };
